module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Ge-Ha-Ib-Ja.07b82673.png";